<template>
    <el-dropdown v-if="isShow" @command="handleClick" class="lang-seletor">
        <img class="auth-icon-lang" src="../../../../assets/language.svg" alt="" width="17" height="17">
        <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="item in langList" :key="item.value" :command="item">
                {{item.name}}
            </el-dropdown-item>
        </el-dropdown-menu>
    </el-dropdown>
</template>
<script>
// import { switchLang } from '@/modules/index/api/user';
import store from '@/store/index';
export default {
    name: 'Lang',
    data() {
        // 语言编码参考 https://www.cnblogs.com/jacksoft/p/5771130.html
        return {
            isShow: store.getters.isShowLang || false,
            langList: [
                {
                    name: '中文-简体',
                    value: 'zh-CN'
                },
                {
                    name: 'English',
                    value: 'en-US'
                }
            ]
        };
    },
    methods: {
        handleClick(item) {
            const langCode = item.value;
            this.$store.commit('updateLocale', langCode);
            this.$store.dispatch('UPDATE_LANG').then((res) => {
                this.$i18n.setLocaleMessage(langCode, res);
                this.$i18n.locale = langCode;
                this.$emit('languageChange', langCode);
                this.$eventBus.$emit('languageChange', langCode);
                // this.$message.success(`${this.$t('lang.E202006180030')} ${item.name}`);
                this.$router.go(0);
            });
        }
    }
};
</script>
<style lang="less">
    .lang-seletor {
        cursor: pointer;
        margin-right: 16px;
        .auth-icon-lang{
            vertical-align: middle;
        }
        .el-badge__content.is-fixed {
            right: 17px;
        }
    }
</style>
